module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("2")])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText"
  }, [_vm._v("Ripples raised by that encounter in Sonalby were to spread throughout the Vales in the fortnights that followed and give rise to major waves. Before the green moon had eclipsed twice, they disturbed the normal calm of a certain small side valley between Narshvale, Randorvale, and Thovale, whose only claim to distinction was that the little settlement near its north end was home to the largest assembly of strangers on Nextdoor. They called it Olympus.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_vm._v("The Pinkney Residence was not as grand as the palaces of the monarchs or high priests of the vales, but it was spacious and luxurious by local standards, having recently been rebuilt from the ground up. In design it more closely resembled the sort of bungalow favored by white men in certain tropical regions of Earth than anything a native of the Vales would have conceived. Within the oversized and overfurnished drawing room, lit by a multitude of candles in silver candlesticks, a man with a fair baritone voice was singing “Jerusalem” accompanied by a lady playing a harp, because the Service’s efforts to instruct their local craftsmen in the construction of a grand piano had so far failed to meet with success. The audience consisted of eight ladies in evening gowns and six gentlemen in white tie and tails.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("‘I shall not ‘cease,’")]), _vm._v("” the singer asserted, “"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("‘from mental fight, Nor shall my sword sleep in my hand….’")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Two more men had slipped out to the veranda to smoke cigars and contemplate the peace of the evening. The warmth of the day lingered amid scents of late-season flowers and lush shrubbery, although the sky was long dark. Amid an escort of stars, red Eltiana and blue Astina peered over jagged peaks already dusted with the first snows of fall.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“It is a rum do.” The taller man was spare, distinguished by an unusually long nose. He had grace and confidence and—on appropriate occasions—a wry, deprecating grin. Like most strangers, he did not discuss his age or past. Although he appeared to be in his middle twenties, he was rumored to have participated in a cavalry charge at the battle of Waterloo, more than a hundred years ago. “Never expected him to start that way.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Never expected him to start at all,” his companion complained. “Thought we’d heard the last of him. Thought Zath had got him, or he’d gone native.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Oh, no. I always expected Mr. Exeter to surface again. I just didn’t expect him to cock a snoot at the Chamber quite so blatantly or quite so soon.” The taller man drew on the cigar so it glowed red in the gloom. Then he murmured, “Very rum! I wonder how he went about it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I wonder how he’s managing to stay alive at all.” The other man was shorter and plump, although he appeared to be no older. He parted his hair in the middle and tended to close his eyes when he smiled.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“That’s what I meant. Zath should have bowled him out in the first over. Think we ought to stop him, do you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Stop who?” demanded another voice. “What are you two plotting out here? Arranging a little something behind the Committee’s backs?” Ursula Newton came striding out and peered suspiciously at the two men, one after the other. She was below average height, but her evening gown revealed very muscular arms and unusually broad shoulders for a woman. She was loud and had never been compared to shrinking violets.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Certainly not!” said the shorter man.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Jumbo?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Of course we were,” said the man with the long nose, unabashed. “Pinky was just about to ask me to name the most efficient assassin on our staff at the moment, weren’t you, Pinky?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("His companion muttered, “I say!” disapprovingly. “Nothing like that.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“The fact is,” Jumbo explained, “that young Edward Exeter has surfaced up in Joalvale, preaching to the unwashed, openly proclaiming himself to be the Liberator foretold.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Great Scot!” Ursula frowned. “You’re sure?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Quite sure,” Pinky said fussily. “Agent Seventy-seven. He’s a very sound chap, knows Exeter quite well. Very well, actually.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“And how long has this been going on?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“He’d been at it about three days when Seventy-seven saw him. Seventy-seven scampered back here right away to let us know. Very sound thinking. I commended him on his initiative. It did take him four days to get here, though, so the situation may have undergone modification.”")])]), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“Exeter may be dead, you mean. But if we’ve heard, then the Chamber’s heard, sure as little apples.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Oh, quite, quite.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The patter of applause having died away, the baritone had unleashed his next song.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“‘And this is the law I will maintain,")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Until my dying day, sir….’”")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The men smoked in silence, and Ursula leaned on the rail between them, scowling at the night.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Could be serious,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“‘That whatsoever king shall")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("reign…’”")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Absolutely,” Pinky agreed.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“‘I will be the vicar of Bray, sir….’”")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“You’re going to send someone to bring him in?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“That was what we were debating when you arrived.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Jumbo remarked, sounding amused.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“It’s a matter for the Committee,” Ursula said, “but of course you haven’t told Foghorn yet, have you? Want to get it all settled beforehand, don’t you? You two and your cronies.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Not settled,” Pinky protested. “Dear me, no. Not settled. Didn’t want to spoil a delightful evening by bringing up business. But I knew Jumbo would be interested. Thought he might have a few ideas. And you, too, my dear. You agree we ought to send someone to have a word with Exeter?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Just to have a word with him?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“The emissary’s terms of reference would have to be very carefully drawn,” Pinky said cautiously. “A certain amount of discretion might be permitted.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Jumbo coughed as if he had swallowed more smoke than he intended. “Spoken like a true gentleman—Cesare Borgia, say, or Machiavelli. Well, he certainly won’t let me near him. Not after what happened the last time.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“If he has any brains at all,” Ursula said, “he won’t let any of us near him. Except Smedley, perhaps. Old school chum? Yes, he’d listen to Julian.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Pinky closed his eyes and smiled beneficently. “Captain Smedley is an excellent young man. But he is rather new here. Do you think he could comprehend all the ramifications of the situation? I am sure he would deliver a message, but would he plead our case with conviction?” He peered at her inquiringly.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“He certainly won’t do the dirty work you’ve got in mind. But remember he has no mana. I think you need to send two emissaries to Exeter—his friend Smedley and someone else, someone who can help the captain out if there is need for a little muscle.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Ah! Brilliant! I expect we should have seen that solution in time, Jumbo, what? Two emissaries, of course! And who should the other one be? What do you think?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Jumbo sighed. “I don’t like this. Not one bit. Rosencrantz and Guildenstern. We need someone with damned good judgment.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“And very few scruples?” Ursula inquired scathingly.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Now, now,” Pinky said soothingly. “Don’t go jumping to conclusions. I am quite hopeful that Mr. Exeter will see reason.”")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“It’s a matter for the Committee. Let them decide. Now come on back inside, both of you, and stop this inner-circle intriguing.” She spun on her heel and strode off into the drawing room, a surprisingly abrupt departure.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Two cigar ends glowed simultaneously. Two smoke clouds wafted into the night air.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Obvious!” said Pinky. “We’d have thought of her on our own, wouldn’t we? Eventually?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Jumbo sighed again. “Truly it is written that the female of the species is more deadly than the male.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Oh, quite,” said Pinky, smiling with his eyes closed. “Quite.”")])])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page10"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e4e6ca7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/futureindefinite_ch02.vue
// module id = 99
// module chunks = 0